module.exports = __webpack_public_path__ + "img/_ic_star_50.5cc40bf8.svg";